import React, { useReducer } from 'react'
import Callout from '@components/DesignSystem/Callout'
import { useTranslation } from 'react-i18next'
import { getInitialState, slice, checkScheduleAtValidity } from './_core'
import { useArticleContext, useScheduler } from '../_core'
import PublishTimeSetting from './PublishTimeSetting'
import PublishButton from './PublishButton'
import ScheduleButton from './ScheduleButton'
import PreviewButton from '../preview'
import 'twin.macro'

export enum PublishModeType {
  PUBLISH_NOW = 'publishNow',
  SCHEDULE_PUBLISH = 'schedulePublish',
}

const PublishTimeSection = () => {
  const {
    articleState: { status, scheduledAt },
    PublishStatusType,
    scheduledArticle,
  } = useArticleContext()
  const { t } = useTranslation('editor')
  const [state, dispatch] = useReducer(
    slice.reducer,
    getInitialState({
      baseDate: new Date(),
      scheduledAt: scheduledAt ? new Date(scheduledAt) : undefined,
      publishStatus: status,
    }),
  )

  const handlePublishModeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(slice.actions.publishModeChanged(e.currentTarget.value as PublishModeType))
  }

  const handlePickerModeChange = (e: React.MouseEvent<HTMLDivElement>) => {
    const mode = e.currentTarget.getAttribute('data-mode')
    dispatch(slice.actions.pickerModeChanged(mode))
  }

  const handlePickerDateChange = (date: Date) => {
    dispatch(slice.actions.pickerDateChanged(date))
  }

  const handlePickerTimeChange = (time: Date) => {
    dispatch(slice.actions.pickerTimeChanged(time))
  }

  const handleCalloutOk = () => {
    dispatch(slice.actions.validityChanged('idle'))
  }

  const isPublished = status === PublishStatusType.PUBLISHED

  const { schedulerStatus, schedule } = useScheduler(state.scheduledAt, scheduledArticle)

  const handleSchedule = () => {
    if (state.validity === 'valid') {
      return schedule()
    }
    const validity = checkScheduleAtValidity(state.scheduledAt, state.baseDate)
    dispatch(slice.actions.validityChanged(validity))
    if (validity === 'valid') {
      schedule()
    }
  }

  return (
    <>
      {!isPublished && (
        <PublishTimeSetting
          publishMode={state.publishMode}
          onChangePublishMode={handlePublishModeChange}
          pickerMode={state.pickerMode}
          onChangePickerMode={handlePickerModeChange}
          scheduledAt={state.scheduledAt}
          onChangePickerDate={handlePickerDateChange}
          onChangePickerTime={handlePickerTimeChange}
          timeOptions={state.pickerTimeOptions}
        />
      )}
      <Callout
        onOk={handleCalloutOk}
        visible={
          state.validity === 'invalid' && state.publishMode === PublishModeType.SCHEDULE_PUBLISH
        }
        title={t('warnings.inValidScheduleTime.title')}
        message={t(`warnings.inValidScheduleTime.message`)}
      />
      <div role="group" tw="space-y-4">
        {state.publishMode === PublishModeType.PUBLISH_NOW && <PublishButton />}
        {state.publishMode === PublishModeType.SCHEDULE_PUBLISH && (
          <ScheduleButton status={schedulerStatus} onClick={handleSchedule} />
        )}
        <PreviewButton className="preview" />
      </div>
    </>
  )
}

export default PublishTimeSection
